/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneNewChecklistSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-NEWCL-001
 * PURPOSE: Draft checklist sheet wrapping QaNewChecklistDialog.
 * LANDMINE: opens in cards every time (a 6-column table is unreadable at phone
 *      width); the table stays one tap away and fills the full-height sheet.
 */
import { useEffect, useState } from 'react'
import { MobileSheet } from '@quotech/ui'
import type { QaApi } from '../../../../qa/qaApi'
import type { JobHubHttpClient } from '../../../../jobHubDataAdapter'
import { QaNewChecklistDialog, type QaNewChecklistLayout } from '../../build/QaNewChecklistDialog'
import { QA_PHONE_CONTROLS } from '../qaPhoneControlInventory'

export function QaPhoneNewChecklistSheet({
  open,
  onClose,
  areaId,
  api,
  client,
  onCreated,
  onMutated,
}: {
  open: boolean
  onClose: () => void
  areaId: string
  api: QaApi
  client?: JobHubHttpClient
  onCreated: (id: string) => void
  onMutated: () => void
}) {
  const [layout, setLayout] = useState<QaNewChecklistLayout>('cards')
  useEffect(() => { if (open) setLayout('cards') }, [open])
  return (
    <MobileSheet open={open} onClose={onClose} title="New checklist" size="full">
      <div data-qa-phone-control={QA_PHONE_CONTROLS.newChecklistDraft} className="flex h-full min-h-0 flex-col p-3">
        <QaNewChecklistDialog
          areaId={areaId}
          api={api}
          client={client}
          onCreated={onCreated}
          onMutated={onMutated}
          onCancel={onClose}
          layout={layout}
          fill
          onToggleLayout={() => setLayout((current) => (current === 'cards' ? 'table' : 'cards'))}
        />
      </div>
    </MobileSheet>
  )
}
